import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Star, Quote } from "lucide-react";

const testimonials = [
  {
    name: "Marie L.",
    location: "Launaguet",
    text: "Service impeccable pour mes rendez-vous médicaux à la Clinique de l'Union. Le chauffeur est toujours ponctuel et très agréable. Je recommande vivement !",
    service: "Transport Médical VSL",
    rating: 5,
  },
  {
    name: "Jean-Pierre D.",
    location: "Aucamville",
    text: "J'utilise RSE TAXI pour mes déplacements professionnels vers l'aéroport de Blagnac. Toujours à l'heure, véhicule propre et confortable. Un vrai plus !",
    service: "Course Professionnelle",
    rating: 5,
  },
  {
    name: "Sophie M.",
    location: "Castelginest",
    text: "Parfait pour nos sorties en famille. Le chauffeur a prévu un siège enfant sans qu'on ait besoin de le demander. Service au top, tarifs corrects.",
    service: "Course Privée",
    rating: 5,
  },
  {
    name: "Alain B.",
    location: "Saint-Alban",
    text: "Conventionné CPAM, aucune avance de frais pour mes séances de dialyse. Le chauffeur m'aide à monter et descendre. Humain et professionnel.",
    service: "Transport Médical VSL",
    rating: 5,
  },
];

export default function TestimonialsSection() {
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrent((prev) => (prev + 1) % testimonials.length);
    }, 5000);
    return () => clearInterval(timer);
  }, []);

  const t = testimonials[current];

  return (
    <section className="py-20 md:py-28 bg-secondary/30" data-testid="testimonials-section">
      <div className="max-w-4xl mx-auto px-4 sm:px-6">
        <motion.div
          className="text-center mb-14"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.6 }}
        >
          <span className="text-amber-400 font-tagline text-sm tracking-[0.3em] uppercase font-semibold">
            Ils nous font confiance
          </span>
          <h2 className="text-3xl md:text-4xl font-bold tracking-tight text-white mt-3">
            Avis de nos clients
          </h2>
        </motion.div>

        <div className="relative min-h-[280px]">
          <AnimatePresence mode="wait">
            <motion.div
              key={current}
              initial={{ opacity: 0, x: 50 }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: -50 }}
              transition={{ duration: 0.4 }}
              className="bg-card border border-white/10 rounded-3xl p-8 md:p-10 relative"
              data-testid={`testimonial-${current}`}
            >
              <Quote className="h-10 w-10 text-amber-500/20 absolute top-6 right-8" />

              {/* Stars */}
              <div className="flex gap-1 mb-5">
                {Array.from({ length: t.rating }).map((_, i) => (
                  <Star key={i} className="h-5 w-5 fill-amber-400 text-amber-400" />
                ))}
              </div>

              <p className="text-zinc-300 text-base md:text-lg leading-relaxed italic mb-6">
                "{t.text}"
              </p>

              <div className="flex items-center justify-between">
                <div>
                  <p className="font-semibold text-white">{t.name}</p>
                  <p className="text-sm text-zinc-500">{t.location}</p>
                </div>
                <span className="px-3 py-1 rounded-full bg-amber-500/10 border border-amber-500/20 text-amber-400 text-xs font-semibold">
                  {t.service}
                </span>
              </div>
            </motion.div>
          </AnimatePresence>
        </div>

        {/* Dots navigation */}
        <div className="flex justify-center gap-2 mt-6">
          {testimonials.map((_, i) => (
            <button
              key={i}
              onClick={() => setCurrent(i)}
              className={`h-2.5 rounded-full transition-all duration-300 ${
                i === current ? "w-8 bg-amber-400" : "w-2.5 bg-zinc-700 hover:bg-zinc-500"
              }`}
              data-testid={`testimonial-dot-${i}`}
              aria-label={`Avis ${i + 1}`}
            />
          ))}
        </div>
      </div>
    </section>
  );
}
